module.exports = __webpack_public_path__ + "media/netdoctor-e6266e13.svg";